import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {IFormHistory} from "../../models/form-history-interface";
import {BaseForm} from "../../models/base-form";
import Helpers from "../../utils/helpers";

@Injectable()
export class ApplicantFormControllerService implements IFormHistory {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getHistoryPage(serviceId: string, page: number): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/applicant-form/pagedhistory?pageNo=" + page + "&pageSize=12") as Observable<any[]>;
  }

  public getApplicantForm(serviceId: string, reusable: boolean): Observable<BaseForm> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/applicant-form?reusable=" + reusable) as Observable<BaseForm>;
  }

  public createApplicantForm(serviceId: string, form: BaseForm): Observable<BaseForm> {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/applicant-form", body) as Observable<BaseForm>;
  }

  // all possible service fields
  public getAllServiceForms(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/allforms") as Observable<any[]>;
  }

  public saveApplicantForm(form: BaseForm) {
    Helpers.stripCKEditorParagraphWrapper(form.formSchema);
    Helpers.trimRecursiveObj(form);
    const body = JSON.stringify(form);
    return this.http.put(this.baseUrl + "applicant-form/" + form.id, body, {responseType: "text"});
  }

  public activateApplicantForm(formId: string, active: boolean) {
    return this.http.put(this.baseUrl + "applicant-form/activate/" + formId + "/" + active, null, {responseType: "text"});
  }

  public importOldApplicantForm(serviceId: string): Observable<BaseForm> {
    return this.http.post(this.baseUrl + "service/" + serviceId + "/applicant-form/import", null) as Observable<BaseForm>;
  }

  public getHistory(serviceId: string): Observable<any[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/applicant-form/history") as Observable<any[]>;
  }

  // Get form schema for preview only (GET request)
  public getFormSchemaForRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/applicant-form/history/" + revisionNumber + "/schema") as Observable<any>;
  }

  // Revert form to a specific revision (PUT request - triggers cleanup of orphaned relations)
  // Note: Backend endpoint has typo "revison_number" (missing 'i')
  public revertFormToRevision(serviceId: string, revisionNumber: string): Observable<any> {
    return this.http.put(this.baseUrl + "service/" + serviceId + "/applicant-form/history/" + revisionNumber, null, {responseType: "text"}) as Observable<any>;
  }

}
